import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import loadData from "./data";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import getExamsPageData from "./data/getExamsPageData";

const ExamsPost = loadable(() => import("./ExamsPost"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    const slug = props?.match?.params?.slug;
    const isDraft =
      typeof window !== "undefined" && window.location.pathname?.startsWith("/drafts-exams/");

    dispatch(getExamsPageData({ slug, isDraft }));
  }, [dispatch, props?.match?.params?.slug]);

  return (
    <ErrorBoundary>
      <ExamsPost {...props} />
    </ErrorBoundary>
  );
};

export { loadData };
